// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"CardPageLayout_container__BLTYl","footer":"CardPageLayout_footer__KtWa7"};